module.exports = __webpack_public_path__ + "static/media/app-dev-phone.b97f7f98.svg";